import { defineComponent as _defineComponent } from 'vue'
import SearchableTradeList from 'ah-trades/src/components/lists/SearchableTradeList.vue';
import {
  Client,
  NotificationEventType,
  NotificationType,
  openTradeStatuses,
  openTradeStates,
  fxHedgingInstruments,
} from 'ah-api-gateways';
import { Subscription } from 'rxjs';
import CollateralInfoBlock from 'ah-trades/src/components/collaterals/CollateralInfoBlock.vue';
import OnBehalfOf from 'ah-common-lib/src/onBehalfOf/OnBehalfOf';
import { useWalletsStore } from '@/app/store/walletsModule';
import { useNotificationsStore } from 'ah-notifications/src/store';
import { useAuthStore } from '@/app/store/authStore';
import { partnerTradeReportTableFieldsFull } from 'ah-trades/src/models/tradeTableFields';
import { computed, onBeforeMount, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { useRoute, useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenPositionsView',
  props: { clientId: { type: String, required: false } },
  setup(__props) {

const props = __props;

const tradeEvents = [
  NotificationType.TRADE_CONFIRMED,
  NotificationType.TRADE_REJECTED,
  NotificationType.POSITION_STATUS_OPEN,
  NotificationType.POSITION_STATUS_CLOSE,
];



const tradeList = ref<InstanceType<typeof SearchableTradeList>>();

const onBehalfOfClient = ref<Client>();

const eventsSubscription = ref<Subscription>();

const notificationsStore = useNotificationsStore();

const walletStore = useWalletsStore();

const authStore = useAuthStore();

const requestManager = useRequestManager().manager;

const services = getServices();

const route = useRoute();

const router = useRouter();

const isPartnerUser = computed(() => !onBehalfOfClient.value && !authStore.isClientUser);

const partnerId = computed(() => {
  if (isPartnerUser.value) {
    return authStore.loggedInIdentity?.partner.id;
  }

  return undefined;
});

const config = computed(() => {
  if (isPartnerUser.value) {
    return { tableFields: partnerTradeReportTableFieldsFull };
  }

  return undefined;
});

onBeforeMount(() => {
  eventsSubscription.value = notificationsStore.notificationEvents.subscribe((event) => {
    if (event.eventType === NotificationEventType.NOTIFICATION_CREATED && tradeEvents.includes(event.payload?.type!)) {
      tradeList.value!.reload();
    }
  });
  walletStore.loadCollaterals({ force: true });
});

onUnmounted(() => {
  eventsSubscription.value!.unsubscribe();
});

function onClientIdChange() {
  if (props.clientId) {
    requestManager
      .sameOrCancelAndNew(`getClient-${props.clientId}`, services.client.getClient(props.clientId))
      .subscribe((response) => (onBehalfOfClient.value = response));
  }
}

watch(() => props.clientId, onClientIdChange, { immediate: true });

const openTrade = ref<string>();

const readonly = computed(() => route.meta?.readonly || false);

onMounted(() => {
  if (route.query?.drawdown) {
    const { drawdown, ...query } = route.query;
    router.replace({ path: route.path, query });

    openTrade.value = drawdown as string;
  }
});

return { __sfc: true,tradeEvents, props, tradeList, onBehalfOfClient, eventsSubscription, notificationsStore, walletStore, authStore, requestManager, services, route, router, isPartnerUser, partnerId, config, onClientIdChange, openTrade, readonly, SearchableTradeList, openTradeStatuses, openTradeStates, fxHedgingInstruments, CollateralInfoBlock, OnBehalfOf }
}

})